import { type FC } from 'react';
import { LinkType, LINK_TYPE_COLORS } from '@/types/link.types';

interface LinkTypeSelectorProps {
  position: { x: number; y: number };
  onSelect: (linkType: LinkType) => void;
  onCancel: () => void;
}

const linkTypeLabels: Record<LinkType, { label: string; icon: string }> = {
  [LinkType.Hierarchy]: { label: 'Hiérarchie', icon: '↓' },
  [LinkType.Dependency]: { label: 'Dépendance', icon: '⇢' },
  [LinkType.Contribution]: { label: 'Contribution', icon: '+' },
  [LinkType.Contradiction]: { label: 'Contradiction', icon: '⚡' },
  [LinkType.Complementarity]: { label: 'Complémentarité', icon: '∞' },
  [LinkType.FreeForm]: { label: 'Libre', icon: '—' },
};

export const LinkTypeSelector: FC<LinkTypeSelectorProps> = ({ position, onSelect, onCancel }) => {
  return (
    <>
      {/* Backdrop */}
      <div
        onClick={onCancel}
        style={{
          position: 'fixed',
          inset: 0,
          zIndex: 99,
        }}
      />
      {/* Menu */}
      <div
        style={{
          position: 'fixed',
          left: position.x,
          top: position.y,
          zIndex: 100,
          backgroundColor: 'var(--color-surface)',
          border: '1px solid var(--color-border)',
          borderRadius: 'var(--radius-lg)',
          boxShadow: 'var(--shadow-lg)',
          padding: 'var(--spacing-xs)',
          minWidth: 180,
        }}
      >
        <div
          style={{
            padding: 'var(--spacing-xs) var(--spacing-sm)',
            fontSize: 'var(--font-size-xs)',
            color: 'var(--color-text-muted)',
            fontWeight: 600,
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
          }}
        >
          Type de liaison
        </div>
        {Object.values(LinkType).map((lt) => (
          <button
            key={lt}
            onClick={() => onSelect(lt)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 'var(--spacing-sm)',
              width: '100%',
              padding: 'var(--spacing-xs) var(--spacing-sm)',
              backgroundColor: 'transparent',
              border: 'none',
              borderRadius: 'var(--radius-md)',
              color: 'var(--color-text)',
              fontSize: 'var(--font-size-sm)',
              cursor: 'pointer',
              textAlign: 'left',
              transition: 'var(--transition-fast)',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = `${LINK_TYPE_COLORS[lt]}20`;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent';
            }}
          >
            <span
              style={{
                width: 20,
                height: 20,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: 'var(--radius-sm)',
                backgroundColor: LINK_TYPE_COLORS[lt],
                color: '#fff',
                fontSize: 12,
                fontWeight: 700,
              }}
            >
              {linkTypeLabels[lt].icon}
            </span>
            <span>{linkTypeLabels[lt].label}</span>
          </button>
        ))}
      </div>
    </>
  );
};

export default LinkTypeSelector;
